import { call, put } from 'redux-saga/effects';
import { updateChartOfAccountsTemplateName } from '../api';
import {
  fetchChartOfAccountsTemplatesRequest,
  updateChartOfAccountsTemplateNameFailure,
  updateChartOfAccountsTemplateNameSuccess,
} from '../actions';
import { UpdateChartOfAccountsTemplateNameRequestAction } from '../types';
import { ApiError } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* updateChartOfAccountsTemplateNameSaga(
  action: UpdateChartOfAccountsTemplateNameRequestAction
) {
  try {
    const { templateId, name } = action.payload;

    const response = yield call(
      updateChartOfAccountsTemplateName,
      templateId,
      name
    );

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(updateChartOfAccountsTemplateNameSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.template-name-updated-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh templates list so UIs reflect the updated name
    yield put(fetchChartOfAccountsTemplatesRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateChartOfAccountsTemplateNameFailure());
  }
}

